module.exports = __webpack_public_path__ + "img/vertical_6_3_8011.ea9b2bb8.png";